import { Box, Button, FormLabel, Typography } from "@mui/material"
import { MapIssueLog } from "../../../components/Table/mapping-function/TableMapping";
import { PackageTable } from "../../../components/Table/component/PackageTable";
import { useState } from "react";
import { CloseIkn, OffIkn, OnIkn } from "../../../utils/icon/Private-Pages/Icon";
import { Model_1 } from "../../../components/public/Model";
import { Textarea } from "../../../components/public/Textarea";


export const IssueLog = () => {
    const [searchTerm, setSearchTerm] = useState('');
    const [tableData, setTableData] = useState(MapIssueLog(new Array(Math.round(Math.random() * (5000 - 5 + 1)) + 5).fill(4)));
    const [page, setPage] = useState(1);
    const [rowsPerPage] = useState(10);

    const [threedotss, setThreeDotss] = useState(true);
    const [open, setOpen] = useState(false);
    const [description, setDescription] = useState(null)

    const btns = [
        {
            title: ({ i, rowData }) => {
                return rowData.status?.props?.txt === "Closed" ? (
                    <Box sx={{ display: 'flex', alignItems: 'center' }}>
                        <OffIkn />
                        <Typography sx={{ pl: 1 }}>Open</Typography>
                    </Box>
                )
                    :
                    (
                        <Box sx={{ display: 'flex', alignItems: 'center' }} onClick={() => { setOpen(true) }}>
                            <OnIkn />
                            <Typography sx={{ pl: 1 }}>Close</Typography>
                        </Box>
                    );
            },
            fn: ({ index, i, rowData }) => {
                console.log(
                    "dec",
                    rowData.status?.props?.txt === "Closed",
                    rowData.status,
                    rowData.status?.props?.txt,
                    rowData
                );
            },
            cb: true,
            link: "",
        },
    ];

    const prop = {
        title: 'Issue Log',
        borderBoxStyle: { px: 0 },
        goto: true,
        searchTerm,
        setSearchTerm,
        filteredData: tableData,
        titleStyle: { fontSize: '20px', fontWeight: '600', color: '#000', },
        tableStyle: { OutBox: { borderRadius: "8px", borderBottomLeftRadius: 0, borderBottomRightRadius: 0, }, },
        tableProps: { btnData: btns }, tableStyle: { Invoice: false, isThreeDot2: threedotss, OutBox: { borderRadius: "8px", borderBottomLeftRadius: 0, borderBottomRightRadius: 0, }, threeDot2: { textAlign: "end" }, },
        rowsPerPage,
        page,
        setPage
    }
    return (
        <Box sx={{ width: '100%', }}>
            <Model_1 open={open} setOpen={setOpen} data={{ title: 'Nanba', outBoxStyle: { borderRadius: '12px' } }}>
                <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                    <Typography sx={{ color: '#040815', fontSize: '16px', fontWeight: '600' }}>Comments</Typography>
                    <Button
                        disableRipple
                        disableElevation
                        sx={{ minWidth: "max-content" }}
                        onClick={() => { setOpen(false) }}
                    >
                        <CloseIkn />
                    </Button>
                </Box>
                <Box sx={{ display: 'flex', flexDirection: 'column', mt: 2 }}>
                    <FormLabel
                        sx={{
                            flexGrow: 1,
                            color: "#000000",
                        }}
                    >
                        Reason*
                    </FormLabel>
                    <Textarea Placeholder={'Describe the fix applied to resolve the issue...'} Value={description} onChange={(e) => { setDescription(e.target.value) }} />
                </Box>
                <Box sx={{ display: 'flex', justifyContent: 'end', mt: 2 }}>
                    <Button disableRipple onClick={() => { setOpen(false) }} sx={{ textTransform: 'capitalize', minHeight: 'max-content', minWidth: 'max-content', height: '26px', width: '64px', background: '#FF2800', color: '#fff', '&:hover': { background: '#FF2800' }, }}>Update</Button>
                </Box>
            </Model_1>
            <PackageTable prop={prop} />
        </Box>
    )
}